import {
  ApplicationConfig,
  importProvidersFrom,
  provideBrowserGlobalErrorListeners,
} from '@angular/core';
import { provideHttpClient, withFetch } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import {
  NavigationError,
  provideRouter,
  withEnabledBlockingInitialNavigation,
  withInMemoryScrolling,
  withNavigationErrorHandler,
  withRouterConfig,
  withViewTransitions,
} from '@angular/router';
import { DropdownModule, SidebarModule } from '@coreui/angular';
import { IconSetService } from '@coreui/icons-angular';
import { routes } from './app.routes';

const CHUNK_RELOAD_KEY = 'chunk-reload-at';

/**
 * Tras un despliegue, una pestaña abierta con la versión anterior pide chunks que ya no existen
 * en el servidor ("Failed to fetch dynamically imported module") y el clic en el menú no hace
 * nada. Se recarga la página hacia la ruta pedida para traer la versión nueva. El tope de 10 s
 * evita un bucle si el chunk de verdad falta en el servidor.
 */
function reloadOnStaleChunk(event: NavigationError): void {
  const message = String((event.error as Error | undefined)?.message ?? event.error ?? '');
  if (
    !/dynamically imported module|Loading chunk|Importing a module script failed/i.test(message)
  ) {
    return;
  }
  try {
    const last = Number(sessionStorage.getItem(CHUNK_RELOAD_KEY) ?? 0);
    if (Date.now() - last < 10_000) return;
    sessionStorage.setItem(CHUNK_RELOAD_KEY, String(Date.now()));
  } catch {
    // Sin sessionStorage (modo privado estricto) se recarga igual: peor es dejar el clic muerto.
  }
  window.location.assign(event.url);
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideHttpClient(withFetch()),
    provideAnimations(),
    provideRouter(
      routes,
      withRouterConfig({
        onSameUrlNavigation: 'reload',
      }),
      withInMemoryScrolling({
        scrollPositionRestoration: 'top',
        anchorScrolling: 'enabled',
      }),
      withEnabledBlockingInitialNavigation(),
      withViewTransitions(),
      withNavigationErrorHandler(reloadOnStaleChunk),
      /* withHashLocation(), */
    ),
    importProvidersFrom(SidebarModule, DropdownModule),
    IconSetService,
  ],
};
